"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOrgSelector = exports.useOrgsSelector = void 0;

var _index = require("../index");

var useOrgsSelector = function useOrgsSelector() {
  return (0, _index.useShallowEqualSelector)(function (_ref) {
    var _ref$organizations = _ref.organizations,
        orgsLoading = _ref$organizations.orgsLoading,
        orgMap = _ref$organizations.orgMap;
    return {
      orgsLoading: orgsLoading,
      orgs: orgMap ? Object.keys(orgMap).map(function (key) {
        return orgMap[key];
      }) : null
    };
  });
};

exports.useOrgsSelector = useOrgsSelector;

var useOrgSelector = function useOrgSelector(orgId) {
  return (0, _index.useShallowEqualSelector)(function (_ref2) {
    var orgMap = _ref2.organizations.orgMap;
    return orgMap[orgId];
  });
};

exports.useOrgSelector = useOrgSelector;